import {Component, inject} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {PendoService} from './services/pendo.service';
import {NavbarComponent} from './navbar/navbar.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [NavbarComponent, RouterOutlet],
})
export class AppComponent {
  private pendoService = inject(PendoService);

  constructor() {
    this.pendoService.initialize();
  }
}
